import { NO_AUTH_VIEW } from 'constants/ServerConstants';

import NewsArticlePageV2 from 'pages-no-auth/news-and-blog/NewsArticlePageV2';
import NewsPageV2 from 'pages-no-auth/news-and-blog/NewsPageV2';

import { FOOTER_TYPE_DEFAULT, LANG_COUNTRY } from './routeConstant';
import { PROMO } from '../constants/EntryPoint';

const news = [
    {
        path: ['/news/:slug', `/${LANG_COUNTRY}/news/:slug`],
        component: NewsArticlePageV2,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            section: 'news',
            strapiApi: '/api/v2/news-article/{:slug}',
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            ogType: 'article',
        },
    },
    {
        path: [
            '/news',
            `/${LANG_COUNTRY}/news`,
            '/news/category/:category',
            `${LANG_COUNTRY}/news/category/:category`,
            '/news/category/:category/:page',
            `${LANG_COUNTRY}/news/category/:category/:page`,
        ],
        component: NewsPageV2,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            section: 'news',
            strapiApi: '/api/v2/news/{:category}/{:page}',
            entryPoint: PROMO,
            menuSection: 'company',
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/blog/:slug', `/${LANG_COUNTRY}/blog/:slug`],
        component: NewsArticlePageV2,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            section: 'blog',
            strapiApi: '/api/v2/blog-article/{:slug}',
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            ogType: 'article',
        },
    },
    {
        path: [
            '/blog',
            `/${LANG_COUNTRY}/blog`,
            '/blog/category/:category',
            `${LANG_COUNTRY}/blog/category/:category`,
            '/blog/category/:category/:page',
            `${LANG_COUNTRY}/blog/category/:category/:page`,
        ],
        component: NewsPageV2,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            section: 'blog',
            strapiApi: '/api/v2/blog/{:category}/{:page}',
            entryPoint: PROMO,
            menuSection: 'company',
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
];

export default news;
